(function () {
  'use strict';

  angular
    .module('admin.checklist.users', ['admin.checklist.users.service'])
    .controller('ChecklistUsersCtrl', ChecklistUsersCtrl);

  /** @ngInject */
  function ChecklistUsersCtrl($stateParams, ChecklistUsersService) {
    var vm = this;
    vm.items = [];
    vm.perPage = 25;
    vm.qua = '';
    vm.completed = '';
    vm.checklistId = $stateParams.id;

    function reloadPagination() {
      vm.totalItems = 0;
      vm.oldPage = 0;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1
      };
    }

    reloadPagination();

    function load(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      } else {
        vm.first = false;
      }

      ChecklistUsersService.list(vm.checklistId, vm.oldPage, 25, vm.qua, vm.completed).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }

        for (var i = 0; i < result.results.length; i++) {
          result.results[i].check = false;

          switch (result.results[i]['st-chase']) {
            case 1:
              result.results[i].status = 'ACTIVE'
              break;
            case 2:
              result.results[i].status = 'CHASING'
              break;
            case 3:
              result.results[i].status = 'SKIPPED'
              break;
            case 4:
              result.results[i].status = 'ARCHIVED'
              break;
            default:
              result.results[i].status = 'UNKNOWN'
              break;
          }

          if (result.results[i]["ts"]) {
            result.results[i]["ts"] = new Date(
              parseInt(
                result.results[i]["ts"]
                  .toString()
                  .substring(0, result.results[i]["ts"].toString().length - 3)
              )
            );
          }
          if (result.results[i]["ts-comp"]) {
            result.results[i]["ts-comp"] = new Date(
              parseInt(
                result.results[i]["ts-comp"]
                  .toString()
                  .substring(0, result.results[i]["ts-comp"].toString().length - 3)
              )
            );
          }
          if (result.results[i].u) {
            if (result.results[i].u["ts"]) {
              result.results[i].u["ts"] = new Date(
                parseInt(
                  result.results[i].u["ts"]
                    .toString()
                    .substring(0, result.results[i].u["ts"].toString().length - 3)
                )
              );
            }
            if (result.results[i].u["ts-m"]) {
              result.results[i].u["ts-m"] = new Date(
                parseInt(
                  result.results[i].u["ts-m"]
                    .toString()
                    .substring(0, result.results[i].u["ts-m"].toString().length - 3)
                )
              );
            }
          }
          if (result.results[i]["ts-m"]) {
            result.results[i]["ts-m"] = new Date(
              parseInt(
                result.results[i]["ts-m"]
                  .toString()
                  .substring(0, result.results[i]["ts-m"].toString().length - 3)
              )
            );
          }
        }

        vm.items = result.results;
      });
    };

    load(1);

    vm.load = function () {
      reloadPagination();
      load(1);
    };

    vm.pageChanged = function (newPage) {
      load(newPage);
      $("html, body").animate({ scrollTop: 0 }, 0);
    };

    vm.changeQualified = function() {
      vm.load(1);
    }

    vm.changeCompleted = function() {
      vm.load(1);
    };
  }

})();
